module.exports = __webpack_public_path__ + "static/img/86027A_1_2_C_20210302_LC.fce7b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/86027A_1_2_C_20210302_LC.png
// module id = +P78
// module chunks = 0